function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretleft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.287 3.807a.75.75 0 00-.817.163l-7.5 7.5a.751.751 0 000 1.06l7.5 7.5a.75.75 0 001.28-.53v-15a.75.75 0 00-.463-.693z",
    fill: props.fill
  }));
}

export default SvgCaretleft;